module.exports = __webpack_public_path__ + "img/mile6m.89662a85.jpg";